import { PropsWithChildren, useCallback, useState } from "react";
import TopActionBarContext, { SideBar } from "./TopActionBarContext";
import type { SidebarPayload } from "./TopActionBarContext";

export default function TopActionBarProvider({ children }: PropsWithChildren<{}>) {
  const [currentSidebar, setTopActionBarState] = useState<SideBar>();
  const [sidebarPayload, setSidebarPayload] = useState<SidebarPayload>();

  const value = {
    currentSidebar,
    sidebarPayload,
    showSidebar: useCallback(
      (sidebar: SideBar, payload?: SidebarPayload) => () => {
        setTopActionBarState(sidebar);
        setSidebarPayload(payload);
      },
      []
    ),
    toggleSidebar: useCallback(
      (sideBar: SideBar) => (show: boolean) => {
        setTopActionBarState(show ? sideBar : undefined);
        if (!show) setSidebarPayload(undefined);
      },
      []
    )
  };

  return <TopActionBarContext.Provider value={value}>{children}</TopActionBarContext.Provider>;
}
